import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import {useCallback} from "react";
import {getLessonsByNodeFile} from "api/services/lesson-service";
import {IGetLessonsByNodeFileRequest} from "api/models/request/IGetLessonsByNodeFileRequest";

export const useGetLessonsByNodeFile = () => {
    const {callAPI, loading} = useWorkspaceApiCall<IGetLessonsByNodeFileRequest, any>(getLessonsByNodeFile, '', 'getLessonsByNodeFile.error');

    const fetchLessonsByNodeFile = useCallback(async (nodeFileId: string) => {
        return await callAPI({nodeFileId});
    }, [callAPI]);

    return {fetchLessonsByNodeFile, isLoading: loading};
}